// extracted by mini-css-extract-plugin
export var attachment = "_hm-a";
export var emailContainer = "_hm-4";
export var emailContentPaddedContainer = "_hm-b";
export var emailHeader = "_hm-6";
export var emailIframe = "_hm-3";
export var emailInfoIcon = "_hm-9";
export var emailShortenedSummary = "_hm-e";
export var infoDropdown = "_hm-0";
export var infoRowBoundedContent = "_hm-d";
export var internal = "_hm-5";
export var merchant = "_hm-8";
export var messageInputContainer = "_hm-h";
export var normal = "_hm-7";
export var replyCard = "_hm-f";
export var subtleButton = "_hm-1";
export var subtleButtonIconContainer = "_hm-2";
export var toggleViewRepliesButton = "_hm-c";
export var wrappingText = "_hm-g";